import { createContext, useContext } from 'react'

import { BLUE_300, SELECTED_BLUE, WHITE } from 'constants/styling/theme'

/** `fill`: a selected option gets a blue background. `ring`: it stays white and gets a blue outline instead. */
export type SelectionStyle = 'fill' | 'ring'

const SelectionStyleContext = createContext<SelectionStyle>('fill')

/** Sets how the selectable cards and buttons below it mark their selected state. */
export const SelectionStyleProvider = SelectionStyleContext.Provider

export const useSelectionStyle = (): SelectionStyle => useContext(SelectionStyleContext)

/** Selected-state styling of the `ring` style. */
export const SELECTION_RING_SX = {
  backgroundColor: WHITE,
  borderColor: SELECTED_BLUE,
  boxShadow: `0 0 0 3px ${BLUE_300}`,
} as const
